import React, { useState } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText
} from "reactstrap";
import { connect } from "react-redux";
import firebase from "../../../config/firebase";
import UpdatePassword from "./updatePassword";

// upload image to cloud storage
const uploadImage = async (file, id) => {
  console.log("upload called----", file);
  const storageRef = firebase.storage().ref();
  const fileRef = storageRef.child(`users/${id}/${file.name}`);
  await fileRef.put(file);
  return fileRef.getDownloadURL();
};

const ExamplePage = ({ user }) => {
  //   console.log({ props: user });
  const [displayName, setDisplayName] = useState("");
  const [profileChanged, setProfileChanged] = useState(false);
  const [photoUrl, setPhotoUrl] = useState("");

  const changeButtonState = () => {
    if (user.displayName !== displayName || photoUrl !== "") {
      setProfileChanged(true);
    }
  };

  const updateProfile = () => {
    var user = firebase.auth().currentUser;

    user
      .updateProfile({
        displayName,
        photoURL: photoUrl ? uploadImage(photoUrl, user.uid) : user.photoURL
        //   "https://firebasestorage.googleapis.com/v0/b/heyremote-6db3c.appspot.com/o/users%2F1ENFA1KTEUSy7RlivcmaXLOQJJs1%2Ffavicon.png?alt=media&token=48a68bac-e476-4803-9bde-b3f7c60444d4"
      })
      .then(function() {
        alert("Profile updated successfully!");
      })
      .catch(function(error) {
        alert("Error: " + error.message);
      });
  };

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Account</h3>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label for="exampleEmail">Email</Label>
            <Input
              type="email"
              name="email"
              id="exampleEmail"
              value={user.email}
              disabled
              placeholder="with a placeholder"
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup>
            <Label>Password</Label> <br />
            <UpdatePassword />
          </FormGroup>
          {/* <FormGroup>
            <Label for="examplePassword">Password</Label>
            <Input
              type="password"
              name="password"
              id="examplePassword"
              disabled
              placeholder="password placeholder"
            />
          </FormGroup> */}
        </Col>
      </Row>
      <hr />
      <h4 style={{ marginBottom: "3%" }}>Profile</h4>
      <Row>
        <Col md={6}>
          <FormGroup>
            <Label for="exampleName">Display Name</Label>
            <Input
              type="text"
              name="displayName"
              id="exampleName"
              value={user.displayName}
              placeholder="Display Name"
              onChange={e => {
                changeButtonState();
                setDisplayName(e.target.value);
              }}
            />
          </FormGroup>
        </Col>
        <Col md={6}>
          <Label for="exampleUrl">Change Avatar</Label>
          <Input
            type="file"
            name="photoUrl"
            id="exampleUrl"
            onChange={e => {
              changeButtonState();
              setPhotoUrl(e.target.files[0]);
            }}
          />
        </Col>

        <Col md={12}>
          <Button
            color="warning"
            size="sm"
            onClick={updateProfile}
            disabled={!profileChanged}
          >
            Update Profile
          </Button>{" "}
        </Col>
      </Row>
    </Container>
  );
};

const mapStateToProps = state => {
  console.log({ state: state.authReducer.user });
  return {
    user: state.authReducer.user
    // error: state.authReducer.error
  };
};

export default connect(mapStateToProps, null)(ExamplePage);
